import React from "react";
import { IonButton } from "@ionic/react";
import { handleVoting, useGameState } from "context/GameContext";
// Css
import classes from "./VotingGovernment.module.scss";

const VotingGovernment: React.FC = () => {
  const { code } = useGameState();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Voting Government</h2>
      <p className={classes.description}>Are you agree to this Government?</p>
      <div>
        <IonButton size="small" onClick={() => handleVoting(code, true)}>
          accept
        </IonButton>
        <IonButton size="small" onClick={() => handleVoting(code, false)}>
          decline
        </IonButton>
      </div>
    </div>
  );
};

export default VotingGovernment;
